<template>
  <div class="dialog-wrap">
    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      :show-close="showClose"
      @close="onDialogClose"
      :width="width"
      :modal="modal"
      center>
      <slot></slot>
      <span slot="footer" class="dialog-footer" v-if="showBtns">
        <el-button @click="dialogVisibleCancelClick">{{cancelBtnText}}</el-button>
        <el-button type="primary" @click="dialogConfirmClick">{{confirmBtnText}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'commonpagination',
  props: {
    title: {
      required: false,
    },
    dialogVisible: {
      required: true,
      default: false
    },
    showClose: {
      default: false
    },
    showBtns: {
      type: Boolean,
      default: true
    },
    cancelBtnText: {
      default: '取消',
    },
    confirmBtnText: {
      default: '确定'
    },
    width: {
      default: '30%'
    },
    modal: {
      type: Boolean,
      default: true
    }
  },
	data() {
	  return {
      centerDialogVisible: this.dialogVisible
	  };
	},
  computed: {
  },
  mounted() {
    
  },
	methods: {
	  dialogConfirmClick() {
      this.$emit('confirm')
    },
    dialogVisibleCancelClick() {
      this.$emit('cancel')
    },
    onDialogClose() {
      this.$emit('dialog-close')
    }
	},
  watch: {
    dialogVisible(val) {
      this.centerDialogVisible = val;
    }
  }
}
</script>

<style lang="less" scoped>

</style>
